(function () {
  'use strict';

  if (window.__dgIronBookingRetryGuard) return;
  window.__dgIronBookingRetryGuard = true;

  function isEligibleIronProductPage() {
    var path = window.location.pathname || '';
    if (!/^\/products\/iron-therapy(?:-|\/?$)/.test(path)) return false;
    return path.indexOf('/products/lp-iron-therapy') === -1;
  }

  if (!isEligibleIronProductPage()) return;

  var bookingSeq = 0;
  var openedSeq = 0;

  function calendarOpen() {
    if (document.body && document.body.classList.contains('ReactModal__Body--open')) return true;

    var modals = document.querySelectorAll('.ReactModalPortal .ReactModal__Content');
    for (var i = 0; i < modals.length; i++) {
      if (modals[i].offsetParent !== null) return true;
    }
    return false;
  }

  function productRoot() {
    return (
      document.querySelector('#custom__product-variant-desk') ||
      document.querySelector('.featured-product') ||
      document.querySelector('main')
    );
  }

  function bookingButton() {
    var root = productRoot();
    var btn = root && root.querySelector('button.easy_appointment_custom');
    if (!btn) btn = document.querySelector('button.easy_appointment_custom');
    if (btn && btn.offsetParent === null) return null;
    return btn;
  }

  function watchForOpen(seq, checksLeft) {
    if (seq !== bookingSeq || openedSeq === seq) return;
    if (calendarOpen()) {
      openedSeq = seq;
      return;
    }
    if (checksLeft > 0) {
      setTimeout(function () {
        watchForOpen(seq, checksLeft - 1);
      }, 150);
    }
  }

  function retryIfNeeded(seq, attempt) {
    if (seq !== bookingSeq || openedSeq === seq) return;
    if (calendarOpen()) {
      openedSeq = seq;
      return;
    }
    if (attempt >= 2) return;

    var btn = bookingButton();
    if (!btn) return;

    btn.click();
    watchForOpen(seq, 20);

    setTimeout(function () {
      retryIfNeeded(seq, attempt + 1);
    }, 3000);
  }

  document.addEventListener(
    'click',
    function (event) {
      if (!event.isTrusted || !isEligibleIronProductPage()) return;

      var target = event.target && event.target.closest
        ? event.target.closest('button.easy_appointment_custom')
        : null;
      if (!target) return;

      var root = productRoot();
      if (root && !root.contains(target)) return;

      var seq = ++bookingSeq;
      openedSeq = 0;
      watchForOpen(seq, 20);

      setTimeout(function () {
        retryIfNeeded(seq, 0);
      }, 3000);
    },
    false,
  );
})();
